import * as apiGetStartingWith from 'apiAuto/backend/paths/GetAccessoryStartingWithV1';
import * as apiPostSearch from 'apiAuto/backend/paths/PostAccessorySearchV1';
import { AdvancedSearchFilterType } from 'apiAuto/backend/schemas/AdvancedSearchFilterType';
import { ISelectItem } from 'interfaces/ISelectItem';
import * as AccessoryList from 'types/Accessory/Search/AccessoryList';
import * as RangeWithIdList from 'types/Accessory/Search/RangeWithIdList';
import * as Search from 'types/Accessory/Search/Search';

export type Type = {
	data: AccessoryList.Type;
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	pageIndex: number;
	pageSize: number;
	totalCount: number;
	totalPages: number;
	ranges: RangeWithIdList.Type;
};

export function create(): Type {
	return {
		data: AccessoryList.create(),
		hasNextPage: false,
		hasPreviousPage: false,
		pageIndex: 0,
		pageSize: 0,
		ranges: RangeWithIdList.create(),
		totalCount: 0,
		totalPages: 0,
	};
}

export async function getFromApi(search: Search.Type): Promise<Type> {
	const response = await apiPostSearch.callApi({
		requestBody: Search.mapToApi(search),
	});
	const responseData = response.toNullable();
	if (responseData) return mapFromApi(responseData);
	return create();
}

export async function getFromApiSW(
	searchTerm: string,
	showOnlyDeleted: boolean
): Promise<ISelectItem[]> {
	const response = await apiGetStartingWith.callApi({
		queryParameters: {
			SearchTerm: searchTerm,
			ShowOnlyDeleted: showOnlyDeleted,
			AdvancedSearchFilterSource: undefined as unknown as AdvancedSearchFilterType,
		},
	});
	const responseData = response.toNullable();
	if (responseData) return mapToISelectItem(responseData);
	return [];
}

export function mapFromApi(input: apiPostSearch.ResponseData): Type {
	return {
		...input,
		ranges: RangeWithIdList.mapFromApi(input),
		data: AccessoryList.mapFromApi(input),
	};
}

export function mapToISelectItem(input: apiGetStartingWith.ResponseData): ISelectItem[] {
	return input.accessories.map<ISelectItem>((x) => ({
		id: x.id,
		name: x.description,
	}));
}
